/**
 * Access rules of the bulk import. A Member needs at least one role (epic, to confirm with
 * engineering); flip this one constant if product allows Members without roles.
 */
export const REQUIRE_ROLE_FOR_MEMBER = true;

/** User types an import can assign (the Owner is never importable). */
export const ASSIGNABLE_USER_TYPES = Object.freeze(['member', 'admin']);

/** Role/group chips shown in an Access cell before the `+N` overflow chip. */
export const MAX_VISIBLE_ACCESS_CHIPS = 2;
